import { PromiseVoidFunction } from '@dreryk/react-common';
import { NavTabs } from '@dreryk/react-components';

import { MyAccountPanelNavParams, useMyAccountPanelTabs } from './MyAccountPanel.hooks';

type MyAccountNavTabsProps = {
   readonly onCertificateSave: PromiseVoidFunction;
   readonly onUpdatePersonalData: PromiseVoidFunction;
};

export const MyAccountNavTabs = (props: MyAccountNavTabsProps): JSX.Element => {
   const tabs = useMyAccountPanelTabs({
      onCertificateSave: props.onCertificateSave,
      onUpdatePersonalData: props.onUpdatePersonalData,
   });
   return (
      <>
         <NavTabs<MyAccountPanelNavParams> testId={'myAccount'}>
            {tabs.map((tab) => (
               <NavTabs.Tab key={tab.param} param={tab.param} testId={tab.param} label={tab.label}>
                  {tab.content}
               </NavTabs.Tab>
            ))}
         </NavTabs>
      </>
   );
};
